
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(data=null) {
        const queryString = new URLSearchParams(data).toString();
        const url = `${API_URL}/remissions?${queryString}`; 

        return axios.get(url, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/remissions/${id}`, { headers: authHeader() });
    },
    createData(data) {

        // Obtener el user_id desde el localStorage
        let userId = JSON.parse(localStorage.getItem('user'));

        // Validar el user_id
        if (!userId || !userId.id) {
            throw new Error("User ID no válido. Asegúrate de haber iniciado sesión.");
        }

        data.user_id = userId.id;
        
        return axios.post(`${API_URL}/remissions`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/remissions/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/remissions/${id}`, { headers: authHeader() });
    },
    getDoc(id) {
        return axios.get(`${API_URL}/remissions/export/${id}`, { headers: authHeader(), responseType: 'blob' });
    },
};